import { render, staticRenderFns } from "./CamsEdicao.vue?vue&type=template&id=6f30185e"
import script from "./CamsEdicao.vue?vue&type=script&lang=js"
export * from "./CamsEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports